// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fee-input.inline[data-v-c7703436] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fee-input[data-v-c7703436] .el-input {\n  width: 300px;\n}\n.fee-input .fee-text[data-v-c7703436] {\n  padding-left: 8px;\n  color: #666;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
